"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.pass_reset.subject': '密码重置请求',
    'email.pass_reset.title': '重置您的密码',
    'email.pass_reset.text': '您已请求重置密码。请点击下面的按钮设置新密码。',
    'email.pass_reset.button': '重置密码',
};
